/**
 * @desc 通过参数获取sku列表信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.PlmSkuListResponseRpcDto>>;
export function request(
  body: defs.basics.PlmSkuRequestParamsRpcDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/sku/getSkuListByParams`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
